import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.5",
  cy: "9.5",
  r: "4",
  stroke: "#F69100"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "31",
  cy: "14",
  r: "3.5",
  stroke: "#F69100"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "m16 24 .781-2.5M14 20.5l-.5 2 4.354 3.166a1.549 1.549 0 0 1-1.663 2.606L14.8 27.5m2.7-10 3 3 3.5 1m-7.219 0 .737-2.359a3.51 3.51 0 0 0-6.68-2.157l-1.873 5.621c-.27.809.075 1.695.82 2.109m6.996-3.214 2.719 2 2.5.5m-12.215.714V41.34a2.16 2.16 0 0 0 4.317.108L14.8 27.5m-5.015-2.786L14.8 27.5m.9.5 1.15 7.75.319 3.8c.14 1.662-1.652 2.792-3.092 1.95M30.5 34.5l-.367 3.668a2 2 0 0 1-1.415 1.717l-6.946 2.083a1.826 1.826 0 0 1-1.062-3.495L25.5 37v-4.143l.5-.071L33.5 35l-.117.703a1.973 1.973 0 1 0 3.892.649l.467-2.803a2 2 0 0 0-1.185-2.168L31 29l1.355-5.758a3.272 3.272 0 0 0-5.848-2.651l-3.003 4.204a2 2 0 0 0-.334 1.555l.995 4.974a1.807 1.807 0 0 0 3.558-.63L27 26l2-2.5M35 38l-.5 3.5M33.019 42.526A1.5 1.5 0 0 1 34.44 41.5h.117a1.5 1.5 0 0 1 1.423 1.026l.106.316a.5.5 0 0 1-.474.658h-2.226a.5.5 0 0 1-.474-.658z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }